import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import ReplayModal from "./replay-modal";
import { setOpen } from "../../Redux/ModalReducer";
import {
  FormControl,
  InputLabel,
  LinearProgress,
  MenuItem,
  Select,
  TablePagination,
  TableContainer,
  Table,
  TableHead,
  TableRow,
  TableCell,
} from "@mui/material";
import { Helper } from "../../tools/Helper";
import { api_Routes } from "../../tools/api_Routes";
import DataTable from "./data-table";

const TableSupport = () => {
  const dispatch = useDispatch();

  const [show, setShow] = useState(false);
  const [currentPage, setCurrentPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [selectedItem, setSelectedItem] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const [data, setData] = useState([]);
  const [status, setStatus] = useState(null);
  const [filtersChanged, setFiltersChanged] = useState(false);

  const getData = async () => {
    setIsLoading(true);

    const queryParams = [];
    if (status && status !== "null") queryParams.push(`status=${status}`);

    const queryString = queryParams.length ? `${queryParams.join("&")}` : "";

    const url = `${
      api_Routes.Support.View
    }?${queryString}&per_page=${rowsPerPage}&page=${currentPage + 1}`;

    const { response, message } = await Helper.Get({
      url,
      hasToken: true,
    });
    if (response) {
      setData(response);
    } else {
      setData([]);
    }
    setIsLoading(false);
  };

  const handlePageChange = (event, value) => {
    setCurrentPage(value);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setCurrentPage(0);
  };

  const handleClose = () => {
    setShow(false);
    dispatch(setOpen(false));
  };

  const handleShow = () => {
    setShow(true);
    dispatch(setOpen(true));
  };

  // Effect for filter changes
  useEffect(() => {
    if (filtersChanged) {
      setCurrentPage(0);
      setFiltersChanged(false);
    } else {
      getData();
    }
  }, [filtersChanged, currentPage, rowsPerPage]);

  return (
    <>
      {/* Status Filter */}
      <div className="flex items-start mb-3">
        <FormControl className="w-full md:w-56">
          <InputLabel id="status-select-label">Status</InputLabel>
          <Select
            labelId="status-select-label"
            id="status-select"
            value={status || null}
            onChange={(e) => {
              setStatus(e.target.value);
              setFiltersChanged(true);
            }}
            label="Status"
            sx={{ textAlign: "start" }}
          >
            <MenuItem value="null">All</MenuItem>
            <MenuItem value="pending">Pending</MenuItem>
            <MenuItem value="answered">Answered</MenuItem>
            <MenuItem value="closed">Closed</MenuItem>
          </Select>
        </FormControl>
      </div>
      {isLoading ? (
        <LinearProgress className="mt-8" />
      ) : data && data?.data?.length > 0 ? (
        <>
          <div className="overflow-x-auto">
            <DataTable
              data={data?.data}
              setSelectedItem={setSelectedItem}
              handleShow={handleShow}
            />
          </div>
          <div className="mt-4 flex justify-center items-center">
            <TablePagination
              page={currentPage}
              className="mt-auto"
              onPageChange={handlePageChange}
              count={data.pagination.total}
              rowsPerPage={rowsPerPage}
              onRowsPerPageChange={handleChangeRowsPerPage}
              variant="outlined"
              shape="rounded"
              rowsPerPageOptions={[5, 10, 25, 50]}
            />
          </div>
          <ReplayModal
            show={show}
            handleClose={handleClose}
            selectedItem={selectedItem}
            setFiltersChanged={setFiltersChanged}
          />
        </>
      ) : (
        <TableContainer>
          <Table aria-label="collapsible table">
            <TableHead>
              <TableRow>
                <TableCell
                  align="center"
                  sx={{
                    backgroundColor: "primary.main",
                    color: "white",
                    fontWeight: "bold",
                  }}
                >
                  There are no data yet
                </TableCell>
              </TableRow>
            </TableHead>
          </Table>
        </TableContainer>
      )}
    </>
  );
};

export default TableSupport;
